import * as types from "./actionTypes";
import * as scuolaNewApi from "../../api/scuolaNewApi";

import { beginApiCall, apiCallError } from "./apiStatusActions";

export function loadSchoolDataNewSuccess(schoolData) {
  return {
    type: types.LOAD_SCUOLA_DATA_NEW_SUCCESS,
    schoolData,
  };
}

export function clearDatiScuolaNew() {
  return {
    type: types.SCUOLA_CLEAR_NEW,
  };
}

export function loadSchoolDataNew(codScuola, lang) {
  return function (dispatch) {
    dispatch(beginApiCall());
    return scuolaNewApi
      .getDatiScuola(codScuola, lang)
      .then((c) => {
        dispatch(loadSchoolDataNewSuccess(c));
      })
      .catch((error) => {
        dispatch(apiCallError(error));
        throw error;
      });
  };
}
